import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  typography: {
    fontFamily:
      '"Averta Std", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',

    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,


    h4: {
      fontWeight: 400,
      fontSize: "2.1rem", 
      lineHeight: 1.2,
    },

    // Testi principali (descrizioni, paragrafi)
    body1: {
      fontWeight: 300,
      fontSize: "0.95rem",
      lineHeight: 1.5,
    },

    // Testi secondari 
    body2: {
      fontWeight: 300,
      fontSize: "0.9rem",
      lineHeight: 1.5,
    },

    // Bottoni
    button: {
  textTransform: "none",
  fontFamily:
    '"Averta Std", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  fontWeight: 400,      
  fontSize: "1rem",
  lineHeight: 1.2,
},
  },

  palette: {
    primary: {
      main: "#3975D0",
    },
    secondary: {
      main: "#6CCB8B",
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
        },
      },
    },
  },
});
